module.exports = __webpack_public_path__ + "static/media/memcached.7339e977.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/memcached.png
// module id = 144
// module chunks = 0